import { HttpClientInterceptor, HttpParams, KeycloakAuthHttp, UsuarioInfo, UsuarioInfoUtils } from '@elotech/angular-common';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { HeaderOverrideService } from './header-data-operacao.service';

export class HeaderParamsFolhaInterceptor implements HttpClientInterceptor {

  constructor(
    private _keycloakService: KeycloakAuthHttp,
    private _headerOverrideService: HeaderOverrideService) {
  }

  interceptRequest(httpParams: HttpParams): Observable<HttpParams> {
    if (this._keycloakService.isLogged()) {
      let usuarioInfo = this._keycloakService.getUsuarioInfo();
      return of(httpParams).pipe(tap(() => this.setupHeaders(httpParams, usuarioInfo)));
    }
    return of(httpParams);
  }

  private setupHeaders(httpParams: HttpParams, usuarioInfo: UsuarioInfo) {
    if (usuarioInfo) {
      const dataOperacaoOverride = this._headerOverrideService.dataOperacao;
      const exercicioOverride = this._headerOverrideService.exercicio;
      const mesOverride = this._headerOverrideService.competencia;

      const dataOperacaoPadrao = usuarioInfo.dataOperacao ? usuarioInfo.dataOperacao.toString() : null;
      const exercicioPadrao = usuarioInfo.exercicioPadrao ? usuarioInfo.exercicioPadrao.toString() : null;
      const mesPadrao = usuarioInfo.mesPadrao ? usuarioInfo.mesPadrao.toString() : null;

      const entidadeInfo = UsuarioInfoUtils.getEntidadePrincipal(usuarioInfo);

      httpParams.headersExtra = this._appendHeaderExtraWithOverride(httpParams, 'DATA_OPERACAO', dataOperacaoPadrao, dataOperacaoOverride);
      httpParams.headersExtra = this._appendHeaderExtraWithOverride(httpParams, 'EXERCICIO', exercicioPadrao, exercicioOverride);
      httpParams.headersExtra = this._appendHeaderExtraWithOverride(httpParams, 'COMPETENCIA', mesPadrao, mesOverride);

      if (entidadeInfo) {
        httpParams.headersExtra = this._appendHeaderExtraWithOverride(httpParams, 'ENTIDADE', entidadeInfo.id.toString());
        httpParams.headersExtra = this._appendHeaderExtraWithOverride(httpParams, 'ENTIDADE_NOME', entidadeInfo.descricao);
      }
    }

  }

  private _appendHeaderExtraWithOverride(httpParams: HttpParams, headerParam: string, value: string, overrideValue?: string) {
    if (!httpParams.headersExtra.has(headerParam)) {
      if (overrideValue) {
        return httpParams.headersExtra.append(headerParam, overrideValue);
      } else if (value) {
        return httpParams.headersExtra.append(headerParam, value);
      }
    }
    return httpParams.headersExtra;
  }

}
